import { IconProps } from "../../types/utils";

const Love = ({ color, dimension, ...props }: IconProps) => (
  <svg
    width={dimension || 32}
    height={dimension || 32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M22.5074 5.34863H22.4945C20.8101 5.34863 19.2254 6.00651 18.0324 7.19704L15.9999 9.22973L13.9672 7.19704C12.7744 6.00399 11.1897 5.34863 9.50529 5.34863H9.49243C7.81047 5.35113 6.23351 6.00916 5.05851 7.19435C3.86048 8.37451 3.19995 9.95416 3.19995 11.6463C3.19995 13.3486 3.86048 14.936 5.05335 16.111L15.3523 26.4099C15.5316 26.5892 15.7645 26.6787 16 26.6787C16.2355 26.6787 16.4684 26.589 16.6477 26.4099L26.9416 16.116C28.1397 14.9358 28.8002 13.346 28.8002 11.6462C28.8002 9.95403 28.1397 8.3746 26.9493 7.19942C25.7666 6.00925 24.1872 5.35138 22.5077 5.34872L22.5074 5.34863ZM25.6536 14.8179L15.9997 24.4718L6.34073 14.8129C5.49341 13.9782 5.02749 12.8545 5.02749 11.6461C5.02749 10.4481 5.49337 9.3293 6.34841 8.48701C7.18553 7.64221 8.30429 7.1788 9.49716 7.17629H9.50484C10.7004 7.17629 11.8268 7.64216 12.6741 8.48952L15.3518 11.1672C15.7102 11.5256 16.2887 11.5256 16.6446 11.1672L19.3223 8.48952C20.1696 7.64221 21.2961 7.17629 22.4916 7.17629H22.4993C23.6923 7.17879 24.8084 7.64468 25.6532 8.49469C26.5005 9.32934 26.9664 10.4479 26.9664 11.6461C26.9718 12.8546 26.5034 13.9785 25.6534 14.8181L25.6536 14.8179Z"
      fill={color || "#242424"}
    />
  </svg>
);

export default Love;
